import { ORDER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';
import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Имя пользователя',
    key: 'app_user',
    width: 250,
  },
  {
    title: 'Наименование модуля',
    key: 'module_desc',
    width: 275,
  },
  {
    title: 'Наименование сервиса',
    key: 'service_desc',
    width: 275,
  },
  {
    title: 'Наименование операции',
    key: 'operation_desc',
    width: 275,
  },
  {
    title: 'Подробная информация (сообщение)',
    key: 'message',
    width: 1050,
  },
  {
    title: 'Время создания записи',
    key: 'created_at',
    width: 250,
    orderBy: {
      isNullsFirst: false,
      type: ORDER.DESC,
      order: 1,
    },
  },
];
